export default function TestError(): never {
  throw new Error('Erreur volontaire de test (UX-3)');
}
